<template src= "./index.html"></template>

<script>
import isEmpty from 'lodash/isEmpty'
import { parseISO, format } from 'date-fns'
import optionData from '@/optionData/data'
import {ko} from 'vuejs-datepicker/dist/locale'
import { Tag } from 'element-ui'
import moment from 'moment'
export default {
  name: 'artistList',
  
    data () {
        return {
            ko : ko,
            optionData : optionData,
            state : null,
            source : null,//'direct',
            copyright_type : null,
            apOption : null, // 선급계약여부  
            contract_territory : 'korea',
            releaseType : null,
            releaseTypeOption :  [
                {value: 'ep', label: 'EP'},
                {value: 'album', label:'ALBUM'},
                {value: 'single', label: 'SINGLE'},
            ],
            keywordOption :[
                {value: 'email', label:'Email ID'},
                {value: '_name', label:'권리자명'},
                // {value: 'name', label:'앨범명'},
                {value: 'company', label: '회사명'},
                {value: 'album_ref',label: '자사앨범코드'},
                {value: 'barcode',label: 'UPC',},
                // {value: 'artist',label: '아티스트명',},
                {value: 'artist_english',label: '아티스트명(번역)',},
                {value: 'name_english',label: '앨범명(번역)',},
                {value: 'track_name',label: '트랙명',},
                {value: 'track_isrc',label: '트랙 ISRC',},
                
                {value: 'label',label: '앨범기획사명',},
            ],
            mlOption : [
                {value: 'true',label: 'YES',},
                {value: 'false',label: 'NO',},
            ],

            ml : null,
            keywordType :'barcode',
            keyword : '',
            albumKeyword : null,
            artistKeyword : null,
            videoType : null,
            videoOption:[{label : 'Y', value : 'true'}, {label : 'N', value : 'false'}],

            explicitType : null,
            explicitTypeOption: [{label : 'Y', value : 'explicit'}, {label : 'N', value : 'not_explicit'}],

            startDate :null,
            endDate : null,
            dateType :'release_date' ,
        
            dateOption : [
                {value: 'release_date',label: '발매일',},
                {value: 'start_date',label: '계약시작일',},
                {value: 'created_at',label: '등록일',},
                {value: 'registered_at',label: '접수일',},
            ],

            genreOption : [],
            genre : null,





            total : 0,
            filtered:0,
            page: {
                pageSize : 50,
                currentPage: 1,                       // 현재 페이지
                totalPage: 0,                         // 총 페이지수
            },          
            gridOptions :{ // 테이플 옵션
                onRowClicked: (event)=>{
                    this.viewDetail(event)
                },
            },
            defaultColDef: {
                sortable: false,
                editable: false,
                resizable: true,
                suppressMenu: false,
                rowSelection:'single'
            },
            
            columnDefs: [
                {headerName: '신청방법',      field: 'source',     filter: false,width: 120,cellRenderer: (data) => {
                    let dd = {
                        direct : "Direct",
                        sftp : 'SFTP',
                        "sftp-bulk" : 'SFTP-BULK',
                        easyupload : 'EasyUpload',
                    }
                    let color = {
                        direct : "rgb(48, 102, 111)",
                        sftp : 'rgb(134, 4, 98)',
                        "sftp-bulk" : 'rgb(134 4 4)',
                        easyupload : 'rgb(43 134 4)',
                        
                    }
                return `
                <div class="con-vs-chip vs-chip-primary con-color" 
                style="
                    background-color: ${color[data.value]} !important;
                    color:#fff;
                    line-height:1;
                    padding:3px 10px;
                    margin:10px 0; 
                    font-size:13px;
                    min-width:50px;
                ">
                    <span style="margin:0" class="text-chip vs-chip--text">
                    ${dd[data.value]}
                </span><!----></div>`
                } },
                {headerName: '상태',  field: 'state',  filter: false,width: 100, cellRenderer: (data) => {
                    let dd = {
                        temporary :'임시저장',
                        registration_complete : '접수', 
                        registration_canceled : '유통 취소', 
                        inspection_complete : '검수 완료', 
                        distribution_complete : '유통 완료', 
                        release_complete : '발매 완료', 
                        suspended : '유통중단', 
                        rejected : '반려',
                        trash : '임시삭제'
                    }
                    let color = {
                        temporary : "#9544d0b3",//'임시저장',
                        registration_complete : '#262c49',//'접수', 
                        registration_canceled : '#797979',//'유통 취소', 
                        inspection_complete : '#4092ff',//'검수 완료', 
                        distribution_complete : '#ff9f43',//'유통 완료', 
                        release_complete : '#24c1a0',//'발매 완료', 
                        suspended : '#b8c2cc',//'유통중단', 
                        rejected : '#ea5455',//'반려' 
                        trash : "#737373"
                    }
                return `
                <div class="con-vs-chip vs-chip-primary con-color" 
                style="
                    background-color: ${color[data.value]} !important;
                    color:#fff;
                    line-height:1;
                    padding:3px 5px;
                    margin:13px 0; 
                    font-size:13px;
                    min-width:50px;
                ">
                    <span style="margin:0" class="text-chip vs-chip--text">
                    ${dd[data.value]}
                </span><!----></div>`
                }},
                {headerName: '계약시작일',      field: 'contract.start_date',     filter: false,width: 140,
                cellRenderer: (data) => {
                return this.fixDate(data.value)
                }},
                {headerName: '발매일',      field: 'release_date',     filter: false,width: 140,
                cellRenderer: (data) => {
                return this.fixDate(data.value)
                }},
                {headerName: '자사앨범코드',      field: 'album_ref',     filter: false,width: 150, },
                {headerName: '앨범명',  field: 'name',  filter: false,width: 220},
                {headerName: '앨범아티스트',  field: 'artists',  filter: false,width: 250,cellRenderer: (data) => {
                    let t = data.value
                    let text =  ''
                    for ( var i in t ){
                        if(i != 0){
                        text += ', '
                        }
                        text += t[i].display_name
                    }
                    return text
                }},
                {headerName: 'Explicit',  field: 'explicit',  filter: false,width: 100,cellRenderer: (data) => {
                    let t = data.value
                    if(t){
                        return 'Yes'
                    }else{
                        return 'No'
                    }
                    
                }},
                
                {headerName: '트랙수',      field: 'track_count',     filter: false,width: 80, },
                {headerName: '발매유형',      field: 'release_type',     filter: false,width: 110, },
                {headerName: 'MV 여부',      field: 'has_mv',     filter: false,width: 110, cellRenderer: (data) => {
                    let t = data.value
                    if(t){
                        return 'Yes'
                    }else{
                        return 'No'
                    }
                    
                }},
                {headerName: '발매국가',      field: 'MV 여부',     filter: false,width: 150, },
                {headerName: '발매스토어',  field: 'contract.territory',  filter: false,width: 120,cellRenderer: (data) => {
                    
                    if(data.value == 'korea'){
                        return '국내한정';
                    }else{
                        return data.value ? 'Worldwide' : '';
                    }
                }},
                
                {headerName: '제외국가',  field: 'contract.territory_exception_v2',  filter: false,width: 120,cellRenderer: (data) => {
                    if (!data.value || !data.value.length) return '';
                    return data.value.map(v => v === 'korea' ? '한국' : v).join(', ');
                }},
                {headerName: 'YouTube CID',      field: 'youtube_cid',     filter: false,width: 150, },
                {headerName: 'UPC/EAN',      field: 'barcode',     filter: false,width: 150, },
                {headerName: '장르',  field: 'label',  filter: false,width: 250,cellRenderer: (data) => {
                    let text = ''
                    if(!this.valCheck(data.data.genre1_id)){
                        text = text + data.data.genre1.name_english
                    }
                    if(!this.valCheck(data.data.genre2_id)){
                        text = text +', '+ data.data.genre2.name_english
                    }
                    return text;
                }},
                {headerName: '앨범기획사',  field: 'label',  filter: false,width: 250},
              
                {headerName: 'Licensor ID(Email)',    field: 'licensor.user.email',   filter: false,width: 250},
                {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 250,
                cellRenderer: (data) => {
                    let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
                    let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
                    return fm +' '+ gm
                }},
                {headerName: '회사명',    field: 'licensor.company',   filter: false,width: 250},

                {headerName: '화폐',  field: 'licensor.currency', filter: false,width: 125,
                cellRenderer: (data) => {
                    return data.value ? data.value.toUpperCase() : data.value 
                }},
                {headerName: '사업자여부',  field: 'licensor.entity', filter: false,width: 125,
                cellRenderer: (data) => {
                    let dd ={
                        'corporation': '사업자',
                        'individual' :'개인'
                    }
                    let text = ''
                    if(data.value == 'corporation'){
                        if(data.data.licensor.entity_tax_exemption == true){
                            text = '(면세)'    
                        }else{
                            text = '(비면세)'    
                        }
                    }else{
                        
                    }
                    return dd[data.value] + text ;

                }},
                {headerName: 'MIMS',    field: 'licensor.mims_account',   filter: false,width: 100},
                
                {headerName: '신청구분',      field: 'copyright_type',     filter: false,width: 150, cellRenderer: (data) => {
                    if(data.value == 'new'){
                        return '신규';
                    }
                    if(data.value == 'transfer'){
                        return '이관';
                    }
                }},
                {headerName: '등록일',      field: 'created_at',     filter: false,width: 180,
                cellRenderer: (data) => {

                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                {headerName: '접수일',      field: 'registered_at',     filter: false,width: 180,
                cellRenderer: (data) => {
                return this.fixDate(data.value, 'yyyy-MM-dd HH:mm:ss')
                }},
                
            ],
            tableData:[
            ],       
            
            testMessage: "최고당!",
            releaseStartDate : null,
            releaseEndDate : null,
            hideSftpBulk: true,
        }
    },
    created(){
        if(this.$route.query.page){
            this.page.currentPage= Number(this.$route.query.page)
        }
        if(this.$route.query.keywordType){
            this.keywordType= this.$route.query.keywordType
        }
        if(this.$route.query.keyword){
            this.keyword= this.$route.query.keyword
        }
        if(this.$route.query['date_field']) this.dateType = this.$route.query['date_field'] 
        if(this.$route.query['date_start'] && this.$route.query['date_end'] ) {
            this.startDate = this.$route.query['date_start'] 
            this.endDate = this.$route.query['date_end'] 
        }
        
        
        if(this.$route.query.name){
            this.albumKeyword = this.$route.query.name
        }
        if(this.$route.query.artist){ 
            this.artistKeyword = this.$route.query.artist
        }
        if(this.$route.query._video){ 
            this.videoType = this.$route.query._video
        }
        
        if(this.$route.query.state){
            this.state = this.$route.query.state
        }
        if(this.$route.query.source){
            this.source = this.$route.query.source
        }
        if(this.$route.query.copyright_type){
            this.copyright_type = this.$route.query.copyright_type
        }
        if(this.$route.query.release_type){
            this.release_type = this.$route.query.release_type
        }
        if(this.$route.query._ap){
            this._ap = this.$route.query._ap
        }
        if(this.$route.query._ml){
            this.ml = this.$route.query._ml
        }
        if(this.$route.query.genre){
            this.genre = this.$route.query.genre
        }
        if(this.$route.query.parental_warning){
            this.explicitType = this.$route.query.parental_warning
        }
        if(this.$route.query.show_sftp_bulk === 'true'){
            this.hideSftpBulk = false
        }
    },
    mounted(){
        this.$nextTick(() =>{
            this.getGenreList()
            this.callList()
        })
    },
    watch: {
        'page.currentPage'(e){
            
            this.callList()
        },
        'page.pageSize'(){
            this.list_search()
        }
    },
    methods: {
        shortCut(type){
            this.page.currentPage = 1
            this.copyright_type = null
            this.keywordType = null
            this.keyword = ''
            this.state = null
            this.source = null
            this.dateType = null
            this.startDate = null
            this.endDate = null
            this.releaseType = null
            this._ap = null
            this.ml = null
            this.genre = null
            this.explicitType = null
            this.hideSftpBulk = true
            if(type == 'direct'){
                this.source = 'direct'
                this.state = null
            }
            if(type == 'sftp'){
                this.source = 'sftp'
                this.state = 'registration_complete'
            }
            if(type == 'bulk'){
                this.source = 'sftp-bulk'
                this.state = 'registration_complete'
                this.hideSftpBulk = false  // show sftp-bulk when explicitly selecting it
            }
            if(type == 'easy'){
                this.source = 'easyupload' 
                this.dateType = 'registered_at'
                this.state = 'registration_complete'
            }
            if(type == 'easy1'){
                this.state = 'registration_complete'
                this.source = 'easyupload' 
                this.dateType = 'registered_at'
                let today = new Date()
                this.startDate = moment(today).add(0, 'day').format('yyyy-MM-DD')
                this.endDate = moment(today).add(0, 'day').format('yyyy-MM-DD')
            }
            if(type == 'easy2'){
                this.state = 'registration_complete'
                this.source = 'easyupload' 
                this.dateType = 'registered_at'
                let today = new Date()
                this.startDate = moment(today).add(-1, 'day').format('yyyy-MM-DD')
                this.endDate = moment(today).add(-1, 'day').format('yyyy-MM-DD')
            }
            if(type == 'release0'){
                this.dateType = 'release_date'
                let today = new Date()
                this.startDate = moment(today).format('yyyy-MM-DD')
                this.endDate = moment(today).format('yyyy-MM-DD')
            }
            if(type == 'release1'){
                this.dateType = 'release_date'
                let today = new Date()
                this.startDate = moment(today).add(1, 'day').format('yyyy-MM-DD')
                this.endDate = moment(today).add(1, 'day').format('yyyy-MM-DD')
            }
            if(type == 'releaseWeek'){
                this.dateType = 'release_date'
                let today = new Date()
                this.startDate = moment(today).add(1, 'weeks').startOf('isoWeek').format('yyyy-MM-DD')
                this.endDate = moment(today).add(1, 'weeks').endOf('isoWeek').format('yyyy-MM-DD')
            }
            this.callList() 
        },
        resetSearch (){
            this.page.currentPage = 1
            this.copyright_type = null
            this.keywordType = null
            this.albumKeyword = null
            this.artistKeyword = null
            this.videoType = null
            this.keyword = ''
            this.state = null
            this.source = null
            this.dateType = null
            this.startDate = null
            this.endDate = null
            this._ap = null
            this.releaseType = null
            this.ml = null
            this.genre = null
            this.explicitType = null
            this.hideSftpBulk = true
            this.callList()
        },
        callList(){
            const option = {
                page: this.page.currentPage - 1,
                limit: this.page.pageSize,
                hide_sftp_bulk: this.hideSftpBulk ? 'true' : 'false',
            }
            const query = {}

            if(this.page.currentPage != 1){
                query['page'] = this.page.currentPage
            }
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
                query['keywordType'] = this.keywordType
                query['keyword'] = this.keyword
            }
            if(!this.valCheck(this.albumKeyword)){
                option['name'] = this.albumKeyword
                query['name'] = this.albumKeyword
            }
            if(!this.valCheck(this.genre)){
                option['_genre'] = this.genre
                query['genre'] = this.genre
            }
            if(!this.valCheck(this.artistKeyword)){
                option['artist'] = this.artistKeyword
                query['artist'] = this.artistKeyword
            }
            if(!this.valCheck(this.videoType)){
                option['_video'] = this.videoType
                query['_video'] = this.videoType
            }
            if(!this.valCheck(this.releaseType)){
                option['release_type'] = this.releaseType
                query['release_type'] = this.releaseType
            }
            if(this.ml != null){
                option['_ml'] = this.ml
                query['_ml'] = this.ml
            }
            if(!this.valCheck(this.explicitType)){
                option['parental_warning'] = this.explicitType
                query['parental_warning'] = this.explicitType
            }
            if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate) && !this.valCheck(this.endDate)){
                option['date_field'] = this.dateType
                option['date_start'] = this.startDate
                option['date_end']   = this.endDate
                option['sort']       = this.dateType + ',source'
                option['sortorder']  = 'desc,asc'
                query['date_field']  = this.dateType
                query['date_start']  = this.startDate
                query['date_end']    = this.endDate
            }
            if(!this.valCheck(this.state)){
                option['state'] = this.state
                query['state'] = this.state
            }
            if(!this.valCheck(this.source)){
                option['source'] = this.source
                query['source'] = this.source
            }
            if(!this.valCheck(this.copyright_type)){
                option['copyright_type'] = this.copyright_type
                query['copyright_type'] = this.copyright_type
            }
            if(!this.valCheck(this.apOption)){
                option['_ap'] = this.apOption
                query['_ap'] = this.apOption
            }
            if(!this.hideSftpBulk){
                query['show_sftp_bulk'] = 'true'
            }

            this.$router.replace({ query }).catch(() => {})
            this.loadingShow()
            this.$store.dispatch('LIST_ALBUM_V2', option)
            .then(result => {
                this.loadingHide()
                this.tableData = result.items
                this.total     = result.total
                this.filtered  = result.filtered
                const remainder = parseInt(this.filtered % this.page.pageSize) > 0 ? 1 : 0
                this.page.totalPage = parseInt(this.filtered / this.page.pageSize) + remainder
            }).catch(error => {
                this.loadingHide()
                const status = error.response ? error.response.status : error.status
                if(status === 401){
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(() => { this.$router.push('/login') })
                } else {
                    this.alert({ msg: error.response?.data?.message || '오류가 발생했습니다.' })
                }
            })
        },
        getExcelFile(response){
            let filename = "",
                disposition = response.headers["content-disposition"];
                
            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/, matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }

            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
                window.navigator.msSaveOrOpenBlob(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                    filename);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            }
        },
        getExcel(){
            
        
        },
        releaseExcel(){
            
            const option = {
            }
            if(!this.valCheck(this.releaseStartDate )&& !this.valCheck(this.releaseEndDate) ){
                option['start_date'] = this.releaseStartDate
                option['end_date'] = this.releaseEndDate
            }

            this.loadingShow();
            this.$store.dispatch('GET_RELEASE_NOTICE_EXCEL', option)
            .then(result =>{
                this.loadingHide();
                console.log('result',result)
                this.getExcelFile(result)
            }).catch(error=>{
            const status = error.status
            this.loadingHide();
            switch(status){
                
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message})
                break;
            }
            })
        },
        list_search(){
        this.page.currentPage = 1  // 초기화
        this.callList()
        },
        viewDetail(event){
            this.$router.push('album/detail/'+event.data.id)
        },

        albumListExcel(){
            
            const option = {
                sortorder: 'desc,asc',
            }
            if(this.keywordType && this.keyword != '') {
                option[this.keywordType] = this.keyword
            }
            if( !this.valCheck(this.albumKeyword)){
                option['name'] = this.albumKeyword
            }
            if( !this.valCheck(this.artistKeyword)){
                option['artist'] = this.artistKeyword
            }
            if( !this.valCheck(this.releaseType)){
                option['release_type'] = this.releaseType
            }
            if(this.ml != null ){
                option['_ml'] = this.ml
            }
            
            
            if(!this.valCheck(this.dateType) && !this.valCheck(this.startDate )&& !this.valCheck(this.endDate) ){
                
                option['date_field'] = this.dateType
                option['date_start'] = this.startDate
                option['date_end'] = this.endDate
                option['sort'] = this.dateType +',source'
            }
            if(!this.valCheck(this.state)){
                option['state'] = this.state
            }
            if(!this.valCheck(this.source)){
                option['source'] = this.source
            }
            if(!this.valCheck(this.copyright_type)){
                option['copyright_type'] = this.copyright_type
            }
            if(!this.valCheck(this.apOption)){
                option['_ap'] = this.apOption
            }
            if(Object.keys(option).length < 1){
                this.alert({msg:'1개이상의 필터를 설정해주세요.'})
                return false
            }


            this.loadingShow();
            this.$store.dispatch('GET_ALBUM_LIST_EXCEL', option)
            .then(result =>{
                this.loadingHide();
                this.alert({msg: '다운로드 요청을 성공하였습니다. <br/> 작업이 완료되면 알림(slack)으로 전송 될 것입니다.'})
                //this.getExcelFile(result)
            }).catch(error=>{
            const status = error.status
            this.loadingHide();
            switch(status){
                
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                this.alert({msg:error.response.data.message})
                break;
            }
            })
        },
        getGenreList(){
            this.$store.dispatch('GET_GENRE')
            .then(result =>{
                this.genreOption  = result.items // 권리자 목록
            }).catch(error=>{
                const status = error.response.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    break;
                }
            })
        },

    }
}
</script>

<style scoped>

</style>
